import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { ReactNode } from "react";

type ChecklistProps = {
  children?: ReactNode;
};

export function CheckList({ children }: ChecklistProps) {
  return <ul className="my-5 list-none space-y-3 pl-0">{children}</ul>;
}

export function CheckItem({ children }: ChecklistProps) {
  return (
    <li className="my-0 flex items-start gap-3 pl-0">
      <CheckCircleIcon
        aria-hidden="true"
        className="mt-1 h-5 w-5 flex-shrink-0 text-emerald-600"
      />
      <div className="min-w-0 text-gray-700 [&>p:first-child]:mt-0 [&>p:last-child]:mb-0">
        {children}
      </div>
    </li>
  );
}
